module.exports = __webpack_public_path__ + "img/id-card-back-placeholder.718a4ba2.png";